"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYYYYMMDD = void 0;
const getYYYYMMDD = (yourDate) => {
    const date = !yourDate ? new Date() : new Date(yourDate);
    const year = date.getUTCFullYear();
    const _month = date.getUTCMonth() + 1;
    const month = (100 + _month).toString().substring(1);
    const _day = date.getUTCDate();
    const day = (100 + _day).toString().substring(1);
    const YYYYMMDD = `${year}-${month}-${day}`;
    return YYYYMMDD;
};
exports.getYYYYMMDD = getYYYYMMDD;
//# sourceMappingURL=getYYYYMMDD.js.map